import { InjectionToken } from '@angular/core';

export const IS_MOBILE = new InjectionToken<boolean>('is mobile');

export function isMobile(): boolean {
  const toMatch = [/Android/i, /webOS/i, /iPhone/i, /iPad/i, /iPod/i, /BlackBerry/i, /Windows Phone/i];

  return toMatch.some(toMatchItem => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export const IS_MOBILE_PROVIDER = {
  provide: IS_MOBILE,
  deps: [],
  useFactory: isMobile
};

export const MAX_WIDTH_CARD_FOR_MOBILE = 458;
export const PADDING_FOR_MOBILE = 64;
export const SIZE_LITTLE_MOBILE = 320;
export const PADDING_FOR_LITTLE_MOBILE = 44;
